import { createContext, useContext, useState } from 'react';

// Create the Context
const ParamContextProvider = createContext<string | null>(null);

interface ParamProviderProps {
  children: React.ReactNode;
}

export const ParamProvider = ({ children } : ParamProviderProps) => {
  // Read param once on initial load (e.g., ?token=123 or ?userId=abc)
  const [urlParam] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('avatarId'); // Change 'token' to match your specific URL key
  });

  return (
    <ParamContextProvider.Provider value={urlParam}>
      {children}
    </ParamContextProvider.Provider>
  );
};

// Custom hook for easy consumption across components
export const useUrlParam = () => useContext(ParamContextProvider);